<template>
  <div class="concept-match" v-if="showContent">
    <div class="search-area" :class="{ 'search-area--mobile': isMobile }">
      <template v-if="!isMobile">
      <el-row class="search-row">
        <el-col :lg="4" :sm="24" :md="9">
          <span class="search-area-label">日期:</span>
          <el-date-picker
            class="search-area-select"
            :size="isMini"
            v-model="formData.date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            @change="changeDate"
          />
        </el-col>
        <el-col :lg="4" :sm="24" :md="9" class="sm-mt">
          <span class="search-area-label">个股:</span>
          <el-select
            :size="isMini"
            class="search-area-select"
            v-model="selectedSource"
            filterable
            remote
            clearable
            value-key="value"
            placeholder="请输入股票名称"
            :remote-method="searchSourceStock"
            :loading="sourceSearchLoading"
          >
            <el-option
              v-for="item in sourceStockOptions"
              :key="item.value"
              :label="item.label"
              :value="item"
            />
          </el-select>
        </el-col>
        <el-col :lg="4" :sm="24" :md="9" class="sm-mt md-mt">
          <span class="search-area-label">龙头:</span>
          <el-select
            :size="isMini"
            class="search-area-select search-area-select--multiple"
            v-model="selectedTargetStocks"
            filterable
            remote
            multiple
            collapse-tags
            value-key="value"
            placeholder="请输入股票名称"
            :remote-method="searchTargetStock"
            :loading="targetSearchLoading"
            @change="handleTargetSelect"
          >
            <el-option
              v-for="item in allTargetOptions"
              :key="item.value"
              :label="item.label"
              :value="item"
            />
          </el-select>
        </el-col>
        <el-col :lg="5" :sm="24" :md="9" class="sm-mt md-mt">
          <span class="search-area-label">概念:</span>
          <el-select
            :size="isMini"
            class="search-area-select"
            v-model="conceptSource"
            @change="onConceptSourceChange"
          >
            <el-option
              v-for="item in conceptSourceOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-col>
        <el-col :lg="5" :sm="24" :md="9" class="sm-mt md-mt">
          <el-button
            :size="isMini"
            class="analyze-btn"
            type="primary"
            @click="analyze"
            :disabled="!selectedSource || !formData.date"
          >
            开始分析
          </el-button>
        </el-col>
      </el-row>
      </template>
      <template v-else>
        <div class="search-area__row search-area__row--date">
          <span class="search-area-label">日期:</span>
          <el-date-picker
            size="mini"
            class="search-area-select"
            v-model="formData.date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            @change="changeDate"
          />
        </div>
        <div class="search-area__row search-area__row--stock">
          <span class="search-area-label">个股:</span>
          <el-select
            size="mini"
            class="search-area-select"
            v-model="selectedSource"
            filterable
            remote
            clearable
            :popper-append-to-body="false"
            value-key="value"
            placeholder="请输入股票名称"
            :remote-method="searchSourceStock"
            :loading="sourceSearchLoading"
          >
            <el-option
              v-for="item in sourceStockOptions"
              :key="item.value"
              :label="item.label"
              :value="item"
            />
          </el-select>
        </div>
        <div class="search-area__row search-area__row--leader">
          <span class="search-area-label">龙头:</span>
          <el-select
            size="mini"
            class="search-area-select search-area-select--multiple"
            v-model="selectedTargetStocks"
            filterable
            remote
            multiple
            collapse-tags
            popper-class="concept-match-leader-popper"
            value-key="value"
            placeholder="请输入股票名称"
            :remote-method="searchTargetStock"
            :loading="targetSearchLoading"
            @change="handleTargetSelect"
            @visible-change="onLeaderDropdownVisible"
          >
            <el-option
              v-for="item in allTargetOptions"
              :key="item.value"
              :label="item.label"
              :value="item"
            />
          </el-select>
        </div>
        <div class="search-area__row search-area__row--concept">
          <span class="search-area-label">概念:</span>
          <el-select
            size="mini"
            class="search-area-select"
            v-model="conceptSource"
            :popper-append-to-body="false"
            @change="onConceptSourceChange"
          >
            <el-option
              v-for="item in conceptSourceOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button
            size="mini"
            class="analyze-btn"
            type="primary"
            @click="analyze"
            :disabled="!selectedSource || !formData.date"
          >
            开始分析
          </el-button>
        </div>
      </template>
    </div>

    <div class="results-area" :class="{ 'results-area--gap-up': gapUpMode }">
      <div v-if="gapUpMode" class="gap-up-logic-bar">
        <span class="gap-up-logic-bar__hint">
          补涨逻辑匹配：{{ gapUpSourceName }} 与 10/15/20 日 TOP15 对比，可跨栏勾选后确认
        </span>
        <div class="gap-up-logic-bar__actions">
          <el-checkbox v-model="addToReviewTopT0" class="gap-up-logic-bar__t0">入复盘TOP T0</el-checkbox>
          <el-button size="small" @click="goBackGapUp">返回补涨</el-button>
          <el-button size="small" @click="confirmGapUpSwitch">切换</el-button>
          <el-button
            type="primary"
            size="small"
            :disabled="!gapUpSelectedRows.length"
            @click="confirmGapUpLogicMatch"
          >确认匹配</el-button>
        </div>
      </div>
      <div class="window-cols">
        <div
          v-for="col in windowColumns"
          :key="col.key"
          class="window-col"
        >
          <div class="window-col__title">
            {{ col.title }}
            <span class="window-col__count">{{ windowRows(col.key).length }}</span>
          </div>
          <el-table
            :ref="'conceptMatchTable_' + col.key"
            :data="sortedWindowMap[col.key]"
            row-key="code"
            style="width: 100%"
            size="mini"
            border
            @sort-change="(payload) => sortChange(col.key, payload)"
          >
            <el-table-column
              v-if="gapUpMode"
              width="42"
              align="center"
              class-name="gap-up-check-col"
            >
              <template slot="header">
                <el-checkbox
                  :value="isWindowAllSelected(col.key)"
                  :indeterminate="isWindowPartialSelected(col.key)"
                  @change="(v) => toggleWindowAll(col.key, v)"
                />
              </template>
              <template slot-scope="{ row }">
                <el-checkbox
                  :value="isGapUpCodeSelected(row.code)"
                  @change="(v) => toggleGapUpRow(row, v)"
                />
              </template>
            </el-table-column>
            <el-table-column prop="name" label="股票名称" min-width="88">
              <template slot-scope="{ row }">
                <span v-html="highlightMatchedText(row.name, row.matchedNames)"></span>
              </template>
            </el-table-column>
            <el-table-column
              prop="conceptScore"
              :sortable="'custom'"
              label="总分"
              width="64"
            />
            <el-table-column
              prop="matchedConcepts"
              label="概念详情"
              min-width="120"
              class-name="gap-up-concepts-col"
            >
              <template slot-scope="{ row }">
                <div
                  class="gap-up-concept-tags"
                  :class="{ 'gap-up-concept-tags--h5-strip': isMobile }"
                >
                  <el-tag
                    v-for="concept in row.matchedConcepts"
                    :key="`${col.key}-${row.code}-${concept}`"
                    size="mini"
                  >
                    {{ concept }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="gainPercent"
              :sortable="'custom'"
              label="周期涨幅"
              width="84"
            >
              <template slot-scope="{ row }">
                {{ formatGainPercent(row.gainPercent) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { stockApi } from '@/api/stockApi'
import { formatDate } from '@/utils/index'
import { BREAKPOINTS } from '@/utils/device'
import { CONCEPT_SOURCE_OPTIONS, CONCEPT_SOURCE_MERGE } from '@/utils/conceptSource'
import { loadGapUpLogicByCode, saveGapUpLogicEntry } from '@/utils/gapUpLogicMatch'

export default {
  name: 'ConceptMatch',
  data() {
    return {
      isMobile: false,
      isTablet: false,
      showContent: false,
      formData: {
        date: formatDate()
      },
      conceptSource: CONCEPT_SOURCE_MERGE,
      conceptSourceOptions: CONCEPT_SOURCE_OPTIONS,
      selectedSource: null,
      sourceStockOptions: [],
      sourceSearchLoading: false,
      topStockOptions: [],
      manualTargetOptions: [],
      targetSearchOptions: [],
      selectedTargetStocks: [],
      targetSearchLoading: false,
      windowResults: {
        d10: [],
        d15: [],
        d20: []
      },
      windowSort: {
        d10: { prop: '', order: '' },
        d15: { prop: '', order: '' },
        d20: { prop: '', order: '' }
      },
      gapUpMode: false,
      gapUpSourceCode: '',
      gapUpSourceName: '',
      gapUpSourceBoards: null,
      /** 确认匹配时是否写入 AuctionTopLibrary T0 */
      addToReviewTopT0: false,
      /** code -> { code, name, conceptScore, gainPercent }，支持跨栏多选 */
      gapUpSelectedByCode: {},
      gapUpBootstrapping: false
    }
  },
  computed: {
    isMini() {
      return this.isMobile ? 'mini' : ''
    },
    isComputer() {
      return !this.isMobile && !this.isTablet
    },
    windowColumns() {
      return [
        { key: 'd10', title: '10日周期涨幅' },
        { key: 'd15', title: '15日周期涨幅' },
        { key: 'd20', title: '20日周期涨幅' }
      ]
    },
    allTargetOptions() {
      const map = new Map()
      ;[...this.topStockOptions, ...this.manualTargetOptions, ...this.targetSearchOptions].forEach((item) => {
        if (item?.value) map.set(item.value, item)
      })
      return [...map.values()]
    },
    gapUpSelectedRows() {
      return Object.keys(this.gapUpSelectedByCode || {}).map((code) => this.gapUpSelectedByCode[code])
    },
    /** 缓存排序结果，避免勾选时换新数组 */
    sortedWindowMap() {
      return {
        d10: this.sortTableData(this.windowRows('d10'), this.windowSort.d10 || {}),
        d15: this.sortTableData(this.windowRows('d15'), this.windowSort.d15 || {}),
        d20: this.sortTableData(this.windowRows('d20'), this.windowSort.d20 || {})
      }
    }
  },
  methods: {
    checkScreenSize() {
      const width = window.innerWidth
      this.isMobile = width <= BREAKPOINTS.MOBILE
      this.isTablet = width > BREAKPOINTS.MOBILE && width <= BREAKPOINTS.TABLET
      this.showContent = true
    },
    clearWindowResults() {
      this.windowResults = { d10: [], d15: [], d20: [] }
      this.gapUpSelectedByCode = {}
    },
    clearGapUpSelection() {
      this.gapUpSelectedByCode = {}
    },
    isGapUpCodeSelected(code) {
      const c = String(code || '').trim()
      return !!(c && this.gapUpSelectedByCode[c])
    },
    toggleGapUpRow(row, checked) {
      const code = String((row && row.code) || '').trim()
      if (!code) return
      if (checked) {
        this.$set(this.gapUpSelectedByCode, code, {
          code,
          name: row.name,
          conceptScore: row.conceptScore,
          gainPercent: row.gainPercent
        })
      } else if (this.gapUpSelectedByCode[code]) {
        this.$delete(this.gapUpSelectedByCode, code)
      }
    },
    isWindowAllSelected(windowKey) {
      const rows = this.sortedWindowRows(windowKey)
      if (!rows.length) return false
      return rows.every((r) => this.isGapUpCodeSelected(r.code))
    },
    isWindowPartialSelected(windowKey) {
      const rows = this.sortedWindowRows(windowKey)
      if (!rows.length) return false
      const n = rows.filter((r) => this.isGapUpCodeSelected(r.code)).length
      return n > 0 && n < rows.length
    },
    toggleWindowAll(windowKey, checked) {
      const rows = this.sortedWindowRows(windowKey)
      rows.forEach((row) => this.toggleGapUpRow(row, !!checked))
    },
    windowRows(key) {
      return Array.isArray(this.windowResults[key]) ? this.windowResults[key] : []
    },
    sortedWindowRows(key) {
      return (this.sortedWindowMap && this.sortedWindowMap[key]) || []
    },
    formatGainPercent(v) {
      const n = Number(v)
      if (!Number.isFinite(n)) return '—'
      return `${n.toFixed(1)}%`
    },
    onConceptSourceChange() {
      this.clearWindowResults()
    },
    mapStockOption(stock, suffix = '') {
      const code = stock.code
      const name = stock.name || ''
      const extra = suffix || ` (${code})`
      return {
        value: code,
        label: `${name}${extra}`,
        concepts: stock.concepts || [],
        kplConcepts: stock.kplConcepts || [],
        localConcepts: stock.localConcepts || []
      }
    },
    async searchSourceStock(query) {
      if (!String(query || '').trim()) {
        this.sourceStockOptions = []
        return
      }
      this.sourceSearchLoading = true
      try {
        const response = await stockApi.searchStocks(query)
        if (response.success && response.data) {
          this.sourceStockOptions = response.data.map((stock) => this.mapStockOption(stock))
        } else {
          this.sourceStockOptions = []
        }
      } catch (_error) {
        this.$message.error('搜索失败')
      } finally {
        this.sourceSearchLoading = false
      }
    },
    async searchTargetStock(query) {
      if (!String(query || '').trim()) {
        this.targetSearchOptions = []
        return
      }
      this.targetSearchLoading = true
      try {
        const response = await stockApi.searchStocks(query)
        if (response.success && response.data) {
          this.targetSearchOptions = response.data.map((stock) => this.mapStockOption(stock))
        } else {
          this.targetSearchOptions = []
        }
      } catch (_error) {
        this.$message.error('搜索失败')
      } finally {
        this.targetSearchLoading = false
      }
    },
    handleTargetSelect() {
      const topValues = new Set(this.topStockOptions.map((item) => item.value))
      this.manualTargetOptions = this.selectedTargetStocks.filter((item) => !topValues.has(item.value))
    },
    onLeaderDropdownVisible(visible) {
      if (!visible || !this.isMobile) return
      if (this.allTargetOptions.length > 0) return
      if (this.topStockOptions.length > 0) return
      this.getTopStocks()
    },
    async getTopStocks() {
      try {
        const response = await stockApi.searchTopStocks20d(this.formData.date)
        const data = response.data || []
        if (response.success) {
          this.topStockOptions = data.map((stock) =>
            this.mapStockOption(stock, ` (${Number(stock.gainPercent || 0).toFixed(1)}%)`)
          )
          this.selectedTargetStocks = [...this.topStockOptions]
          this.manualTargetOptions = []
        } else {
          this.topStockOptions = []
          this.selectedTargetStocks = []
        }
      } catch (_error) {
        this.$message.error('获取涨幅TOP失败')
      }
    },
    changeDate() {
      this.clearWindowResults()
      this.manualTargetOptions = []
      this.targetSearchOptions = []
      this.getTopStocks()
    },
    highlightMatchedText(text, matchedChars) {
      if (!text || !Array.isArray(matchedChars) || matchedChars.length === 0) return text
      let result = String(text)
      matchedChars.forEach((char) => {
        const escaped = String(char).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        const regex = new RegExp(`(${escaped})`, 'g')
        result = result.replace(regex, '<span class="highlight-name">$1</span>')
      })
      return result
    },
    sortChange(windowKey, { prop, order }) {
      this.$set(this.windowSort, windowKey, {
        prop: prop || '',
        order: order || ''
      })
    },
    sortTableData(data, sortState = {}) {
      const list = Array.isArray(data) ? [...data] : []
      const prop = sortState.prop || ''
      const order = sortState.order || ''
      if (!prop || !order) return list
      return list.sort((a, b) => {
        const av = Number(a[prop])
        const bv = Number(b[prop])
        if (!Number.isFinite(av) && !Number.isFinite(bv)) return 0
        if (!Number.isFinite(av)) return 1
        if (!Number.isFinite(bv)) return -1
        return order === 'descending' ? bv - av : av - bv
      })
    },
    async analyze() {
      if (!this.selectedSource?.value) {
        this.$message.warning('请先选择个股')
        return false
      }
      if (!this.formData.date) {
        this.$message.warning('请先选择日期')
        return false
      }
      try {
        const res = await stockApi.analyzeConceptMatchWindows(
          this.formData.date,
          this.selectedSource.value,
          this.conceptSource
        )
        if (!res?.ok) {
          this.$message.error(res?.message || '分析失败')
          this.clearWindowResults()
          return false
        }
        const windows = res.windows || {}
        this.windowResults = {
          d10: Array.isArray(windows.d10?.rows) ? windows.d10.rows : [],
          d15: Array.isArray(windows.d15?.rows) ? windows.d15.rows : [],
          d20: Array.isArray(windows.d20?.rows) ? windows.d20.rows : []
        }
        if (!this.gapUpMode) {
          this.clearGapUpSelection()
          const total =
            this.windowResults.d10.length +
            this.windowResults.d15.length +
            this.windowResults.d20.length
          this.$message.success(`分析完成，三栏合计 ${total} 条`)
        }
        this.restoreGapUpSelection()
        return true
      } catch (_error) {
        this.$message.error('分析失败')
        this.clearWindowResults()
        return false
      }
    },
    restoreGapUpSelection() {
      if (!this.gapUpMode || !this.gapUpSourceCode) return
      const existing = loadGapUpLogicByCode(this.formData.date)[this.gapUpSourceCode]
      if (existing?.type !== 'match' || !existing.items?.length) {
        this.clearGapUpSelection()
        return
      }
      const next = {}
      const byCode = new Map()
      ;['d10', 'd15', 'd20'].forEach((key) => {
        this.windowRows(key).forEach((row) => {
          if (row?.code) byCode.set(String(row.code), row)
        })
      })
      existing.items.forEach((item) => {
        const code = String((item && item.code) || '').trim()
        if (!code) return
        const row = byCode.get(code)
        next[code] = {
          code,
          name: (row && row.name) || item.name || code,
          conceptScore: (row && row.conceptScore) != null ? row.conceptScore : item.conceptScore,
          gainPercent: (row && row.gainPercent) != null ? row.gainPercent : item.gainPercent
        }
      })
      this.gapUpSelectedByCode = next
    },
    async applyGapUpRouteQuery() {
      const q = this.$route.query
      if (q.gapUp !== '1' || !q.sourceCode) {
        this.gapUpMode = false
        this.gapUpSourceCode = ''
        this.gapUpSourceName = ''
        this.gapUpSourceBoards = null
        this.addToReviewTopT0 = false
        this.clearGapUpSelection()
        return
      }
      this.gapUpMode = true
      this.gapUpBootstrapping = true
      this.gapUpSourceCode = q.sourceCode
      this.gapUpSourceName = q.sourceName || q.sourceCode
      {
        const boardsRaw = Number(q.boards)
        this.gapUpSourceBoards =
          Number.isFinite(boardsRaw) && boardsRaw >= 1 ? Math.floor(boardsRaw) : null
      }
      this.addToReviewTopT0 = false
      this.clearGapUpSelection()
      this.clearWindowResults()
      if (q.date) this.formData.date = q.date
      if (q.conceptSource != null && q.conceptSource !== '') {
        this.conceptSource = Number(q.conceptSource) || CONCEPT_SOURCE_MERGE
      }
      this.selectedSource = {
        value: q.sourceCode,
        label: `${this.gapUpSourceName} (${q.sourceCode})`,
        concepts: [],
        kplConcepts: []
      }
      this.sourceStockOptions = [this.selectedSource]
      try {
        await this.getTopStocks()
        await this.analyze()
      } finally {
        this.gapUpBootstrapping = false
      }
    },
    async bootstrapPage() {
      if (this.$route.query.gapUp === '1' && this.$route.query.sourceCode) {
        await this.applyGapUpRouteQuery()
        return
      }
      this.gapUpMode = false
      this.gapUpSourceCode = ''
      this.gapUpSourceName = ''
      this.gapUpSourceBoards = null
      this.addToReviewTopT0 = false
      this.clearGapUpSelection()
      if (!this.topStockOptions.length) {
        this.changeDate()
      }
    },
    async confirmGapUpLogicMatch() {
      if (!this.gapUpSourceCode) return
      if (!this.gapUpSelectedRows.length) {
        this.$message.warning('请勾选匹配个股')
        return
      }
      const entry = {
        type: 'match',
        items: this.gapUpSelectedRows.map((r) => ({
          code: r.code,
          name: r.name,
          conceptScore: r.conceptScore,
          gainPercent: r.gainPercent
        }))
      }
      saveGapUpLogicEntry(this.formData.date, this.gapUpSourceCode, entry)
      try {
        await stockApi.saveGapUpLogicMatch(this.formData.date, this.gapUpSourceCode, entry)
      } catch (_e) {
        /* sessionStorage 已缓存 */
      }
      let topMsg = ''
      if (this.addToReviewTopT0) {
        try {
          const payload = {
            code: this.gapUpSourceCode,
            name: this.gapUpSourceName || '',
            tradeDate: this.formData.date,
            tag: 'T0'
          }
          if (this.gapUpSourceBoards != null) payload.boards = this.gapUpSourceBoards
          const res = await stockApi.addAuctionTopLibrary(payload)
          if (res?.ok) {
            topMsg = `；已入复盘TOP T0`
          } else {
            topMsg = `；入TOP库失败：${res?.message || '未知错误'}`
          }
        } catch (error) {
          const msg = error?.message || error?.data?.message || error?.response?.data?.message || '入TOP库失败'
          topMsg = `；${msg}`
        }
      }
      this.$message.success(`已保存匹配${topMsg}`)
      this.goBackGapUp()
    },
    async confirmGapUpSwitch() {
      if (!this.gapUpSourceCode) return
      const entry = { type: 'switch' }
      saveGapUpLogicEntry(this.formData.date, this.gapUpSourceCode, entry)
      try {
        await stockApi.saveGapUpLogicMatch(this.formData.date, this.gapUpSourceCode, entry)
      } catch (_e) {
        /* sessionStorage 已缓存 */
      }
      this.$message.success('已标记切换')
      this.goBackGapUp()
    },
    goBackGapUp() {
      this.$router.push({ path: '/gap-up-analysis' })
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
    this.bootstrapPage()
  },
  activated() {
    this.bootstrapPage()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
  }
}
</script>

<style lang="scss" scoped>
.concept-match {
  height: 100%;
  display: flex;
  flex-direction: column;

  .search-area {
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    margin-bottom: 20px;

    .search-row {
      .search-area-label {
        margin-right: 10px;
        color: #606266;
      }

      .search-area-select {
        width: 220px;
      }

      .search-area-select:not(.search-area-select--multiple) {
        ::v-deep .el-input__inner {
          color: #606266;
          -webkit-text-fill-color: #606266;
        }
      }

      /* 多选 collapse-tags：保持与单行输入同高，避免标签换行撑开 */
      .search-area-select--multiple {
        ::v-deep .el-input__inner {
          height: 40px;
          min-height: 40px !important;
          line-height: 40px;
        }

        ::v-deep .el-select__tags {
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          max-width: calc(100% - 32px);
          overflow: hidden;
          top: 50%;
          transform: translateY(-50%);
          line-height: normal;
        }

        ::v-deep .el-select__tags .el-tag {
          flex-shrink: 1;
          max-width: 140px;
          overflow: hidden;
          text-overflow: ellipsis;
          margin: 2px 0 2px 6px;
        }

        ::v-deep .el-select__tags .el-tag:last-child {
          flex-shrink: 0;
          max-width: none;
        }
      }
    }

    /* 多选远程搜索：PC / 平板共用，避免 filter 输入被标签挤没 */
    .search-area-select--multiple {
      ::v-deep .el-select__input {
        flex: 1 1 48px;
        min-width: 48px;
        max-width: 100%;
        margin-left: 4px;
        color: #606266;
        -webkit-text-fill-color: #606266;
        opacity: 1;
        background: transparent;
      }

      ::v-deep &.is-focus .el-select__tags {
        max-width: 100%;
        overflow: visible;
      }

      ::v-deep &.is-focus .el-select__tags .el-tag:not(:last-child) {
        max-width: 72px;
      }

      ::v-deep &.is-focus .el-select__input {
        flex: 1 1 64px;
        min-width: 64px;
      }
    }

    .analyze-btn {
      margin-left: 10px;
    }
  }

  @media screen and (min-width: 1024px) {
    .search-area {
      .search-row.el-row {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        gap: 8px;
      }

      .search-row.el-row > .el-col {
        display: flex;
        align-items: center;
        flex: 0 0 auto !important;
        width: auto !important;
        max-width: none !important;
      }

      .search-row .search-area-label {
        margin-right: 6px;
      }

      .analyze-btn {
        margin-left: 0;
      }

      .search-area-select--multiple {
        width: 240px;

        ::v-deep .el-input__inner {
          height: 32px;
          min-height: 32px !important;
          line-height: 32px;
        }
      }
    }
  }

  .results-area {
    background: #fff;
    padding: 10px 20px 20px 20px;
    border-radius: 4px;
    flex-grow: 1;
    height: 0;
    display: flex;
    flex-direction: column;
    min-height: 0;

    .window-cols {
      display: flex;
      gap: 10px;
      flex: 1;
      min-height: 0;
      overflow: hidden;
    }

    .window-col {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      border: 1px solid #ebeef5;
      border-radius: 4px;
      overflow: hidden;
      background: #fafafa;

      &__title {
        flex-shrink: 0;
        padding: 8px 10px;
        font-size: 13px;
        font-weight: 600;
        color: #303133;
        background: #f5f7fa;
        border-bottom: 1px solid #ebeef5;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      &__count {
        font-size: 12px;
        font-weight: 500;
        color: #909399;
      }
    }

    ::v-deep {
      .window-col .el-table {
        flex: 1;
        background: #fff;

        .el-table__body-wrapper {
          max-height: calc(100vh - 280px);
          overflow-y: auto;
        }

        @media screen and (min-width: 769px) {
          td.gap-up-concepts-col .cell {
            white-space: normal !important;
            word-break: break-word;
          }
        }

        .highlight-name {
          background-color: #fffacd;
          color: #d48806;
          padding: 2px;
          border-radius: 3px;
          font-weight: 500;
        }
      }
    }

    .gap-up-concept-tags {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 4px;
    }

    .gap-up-logic-bar {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      gap: 8px 12px;
      margin-bottom: 10px;
      padding: 8px 12px;
      background: #ecf5ff;
      border: 1px solid #d9ecff;
      border-radius: 4px;

      &__hint {
        font-size: 13px;
        color: #409eff;
      }

      &__actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
      }

      &__t0 {
        margin-right: 4px;
        color: #303133;
        font-size: 13px;
      }
    }
  }

  @media screen and (max-width: 1023px) {
    .results-area {
      .window-cols {
        flex-direction: column;
        overflow: auto;
      }

      .window-col {
        flex: none;
      }

      ::v-deep .window-col .el-table .el-table__body-wrapper {
        max-height: 320px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .results-area {
      ::v-deep td.gap-up-concepts-col .cell {
        overflow: hidden !important;
        vertical-align: middle;
        white-space: normal !important;
      }

      .gap-up-concept-tags--h5-strip {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        gap: 4px;
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
          display: none;
          width: 0;
          height: 0;
        }

        ::v-deep .el-tag {
          flex-shrink: 0;
        }
      }
    }
  }

  @media screen and (max-width: 1023px) {
    .search-area {
      padding: 10px;
      margin-bottom: 10px;

      .search-row {
        .search-area-label {
          display: inline-block;
          margin-bottom: 5px;
        }

        .search-area-select {
          width: calc(100% - 60px);
          max-width: 200px;
        }

        .search-area-select--multiple {
          ::v-deep .el-input__inner {
            height: 28px;
            min-height: 28px !important;
            line-height: 28px;
          }

          ::v-deep .el-select__tags .el-tag {
            max-width: 100px;
          }

          ::v-deep &.is-focus .el-select__tags .el-tag:not(:last-child) {
            max-width: 64px;
          }
        }

        .search-area-select:not(.search-area-select--multiple) {
          ::v-deep .el-input__inner {
            color: #606266;
            -webkit-text-fill-color: #606266;
          }
        }
      }
    }

    .results-area {
      padding: 10px;
    }

    .sm-mt {
      margin-top: 15px;
    }
  }

  @media screen and (min-width: 1024px) and (max-width: 1024px) {
    .md-mt {
      margin-top: 15px;
    }
  }

  /* H5：日期/个股/龙头固定 200px（覆盖 App.vue 全局 el-date-editor width:100%!important） */
  .search-area.search-area--mobile {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;

    .search-area-label {
      flex-shrink: 0;
      width: 40px;
      text-align: right;
    }

    .search-area__row {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      gap: 8px;
      min-width: 0;
      justify-content: flex-start;
    }

    .search-area__row--date,
    .search-area__row--stock,
    .search-area__row--leader,
    .search-area__row--concept {
      gap: 4px;

      ::v-deep .search-area-select,
      ::v-deep .el-date-editor.search-area-select,
      ::v-deep .el-select.search-area-select {
        flex: 0 0 auto !important;
        width: 200px !important;
        max-width: 200px !important;
      }

      ::v-deep .el-input {
        width: 200px !important;
      }

      ::v-deep .el-input__inner {
        color: #606266;
        -webkit-text-fill-color: #606266;
      }

      ::v-deep .el-select__input {
        color: #606266;
        -webkit-text-fill-color: #606266;
        opacity: 1;
        background: transparent;
      }
    }

    .search-area__row--leader {
      position: relative;
      z-index: 2;

      ::v-deep .search-area-select--multiple {
        overflow: visible;

        .el-input {
          overflow: hidden;
        }

        .el-input__inner {
          height: 28px;
          min-height: 28px !important;
          max-height: 28px !important;
          line-height: 28px;
        }

        .el-select__tags {
          display: flex;
          flex-wrap: nowrap !important;
          align-items: center;
          max-width: calc(100% - 28px);
          overflow: hidden;
          top: 50%;
          transform: translateY(-50%);
          line-height: normal;
          white-space: nowrap;
        }

        .el-select__tags .el-tag {
          display: inline-flex;
          flex-shrink: 1;
          max-width: 120px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin: 2px 0 2px 4px;
        }

        .el-select__tags .el-tag:last-child {
          flex-shrink: 0;
          max-width: none;
        }

      }
    }

    .search-area__row--concept {
      .analyze-btn {
        flex-shrink: 0;
        margin-left: 8px;
      }
    }
  }
}
</style>

<style lang="scss">
.concept-match-leader-popper {
  z-index: 3100 !important;
  max-width: calc(100vw - 24px);
}
</style>
